
import DefaultLayout from "./DefaultLayout.vue";
import PageNotFound from "@/layouts/components/PageNotFound";
export default {
  props: ["error"],
  layout: "error", // you can set a custom layout for the error page

  components: { DefaultLayout, PageNotFound },
};
